var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4802 13.5542C10.2245 13.5542 10.0166 13.3463 10.0166 13.0906C10.0166 12.8349 10.2245 12.627 10.4802 12.627C10.7359 12.627 10.9439 12.8349 10.9439 13.0906C10.9439 13.3463 10.7359 13.5542 10.4802 13.5542Z",
    fill: "#39546A",
    stroke: "#39546A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.249 11.2176V7.97206C10.249 7.84409 10.3526 7.74023 10.4808 7.74023C10.609 7.74023 10.7127 7.84409 10.7127 7.97206V11.2176C10.7127 11.3455 10.609 11.4494 10.4808 11.4494C10.3526 11.4494 10.249 11.3455 10.249 11.2176Z",
    fill: "#39546A",
    stroke: "#39546A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3658 3.37695C11.1871 3.06755 10.857 2.87695 10.4997 2.87695C10.1425 2.87695 9.81234 3.06755 9.63371 3.37695L2.94169 14.9679C2.76306 15.2773 2.76306 15.6585 2.94169 15.9679C3.12033 16.2773 3.45045 16.4679 3.80772 16.4679H17.1917C17.549 16.4679 17.8791 16.2773 18.0578 15.9679C18.2364 15.6585 18.2364 15.2773 18.0578 14.9679L11.3658 3.37695Z",
    stroke: "#39556B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/TriangleWarning.8d96f5bb8f4d5f88050b94441ab378cc.svg";
export { ForwardRef as ReactComponent };